import styled from 'styled-components'

interface ITrialModeIndicatorStyledProps {}

export const TrialModeIndicatorStyled = styled.div<ITrialModeIndicatorStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
